export const INDUSTRIES = [
  'Technology', 'Finance & Banking', 'Healthcare',
  'Education', 'Manufacturing', 'Retail & E-commerce',
  'Marketing & Advertising', 'Consulting', 'Legal',
  'Real Estate', 'Media & Entertainment', 'Logistics',
  'Energy & Utilities', 'Food & Beverage',
  'Non-profit & NGO', 'Government', 'Telecommunications',
  'Automotive', 'Agriculture', 'Other'
];

export const COMPANY_TYPES = [
  'Startup', 'SME', 'Corporation',
  'MNC', 'NGO', 'Government'
];

export const COMPANY_SIZES = [
  '1-10', '11-50', '51-200', '201-500', '500+'
];

export const JOB_TYPES = [
  { value: 'full_time', label: 'Full-time' },
  { value: 'part_time', label: 'Part-time' },
  { value: 'internship', label: 'Internship' },
  { value: 'remote', label: 'Remote' },
  { value: 'hybrid', label: 'Hybrid' },
  { value: 'contract', label: 'Contract' },
  { value: 'freelance', label: 'Freelance' },
];

export const CATEGORIES = [
  { value: 'tech', label: 'Technology' },
  { value: 'finance', label: 'Finance' },
  { value: 'marketing', label: 'Marketing' },
  { value: 'design', label: 'Design' },
  { value: 'engineering', label: 'Engineering' },
  { value: 'business', label: 'Business' },
  { value: 'healthcare', label: 'Healthcare' },
  { value: 'education', label: 'Education' },
  { value: 'legal', label: 'Legal' },
  { value: 'other', label: 'Other' },
];

export const BENEFITS = [
  'Health Insurance', 'Transport Allowance',
  'Meal Allowance', 'Remote Work Option',
  'Equity / Stock Options', 'Annual Bonus',
  'Training & Development', 'Flexible Hours',
  'Gym Membership', 'Medical Leave',
];

export const CURRENCIES = [
  'USD', 'EUR', 'GBP', 'PKR', 'INR', 'AED',
  'SAR', 'CAD', 'AUD', 'SGD', 'MYR', 'TRY',
];

export const SKILLS_LIST = [
  'Python', 'JavaScript', 'React', 'Node.js',
  'SQL', 'Java', 'C++', 'Machine Learning',
  'Data Analysis', 'Flutter', 'Swift', 'Kotlin',
  'TypeScript', 'Vue.js', 'Angular', 'Django',
  'AWS', 'Docker', 'Git', 'Figma', 'UI/UX Design',
  'Excel', 'PowerPoint', 'Communication',
  'Leadership', 'Project Management',
  'Digital Marketing', 'SEO', 'Content Writing',
  'Accounting', 'Finance', 'Research', 'Canva',
];

export const STATUS_COLORS = {
  pending: '#F59E0B',
  reviewed: '#4F8EF7',
  shortlisted: '#10B981',
  interview_scheduled: '#10B981',
  hired: '#22D3EE',
  rejected: '#EF4444',
  withdrawn: '#94A3B8',
};

export const STATUS_LABELS = {
  pending: 'Pending',
  reviewed: 'Under Review',
  shortlisted: 'Shortlisted',
  interview_scheduled: 'Interview Scheduled',
  hired: 'Hired',
  rejected: 'Rejected',
  withdrawn: 'Withdrawn',
};